import React, { useEffect, useState, useContext } from "react";
import { Col, Row } from "@pds-react/grid";
import Card from "../../../Card";
import { fetchService } from "../../../../../services/fetchService";
import Config from "../../../../../config";
import UserContext from "../../../../../context/User.context";
import Input from "@pds-react/input";
import Button from "@pds-react/button";
import Loading from "../../../../Loading/Loading";
import { useNavigate, useParams } from "react-router-dom";
import { ValidateRequired, validationUseEffectHelper } from "../../../../Utilities/ValidationHelpers";
import { handleChange } from "../../../../Utilities/FormHelpers";
const CompanyDetailsEdit = () => {
  const { baseUrl } = Config.api;
  const { accessToken } = useContext(UserContext);
  const navigate = useNavigate();
  const params = useParams();
  const validatedParams = {};
  if (Object.keys(params).length !== 0) {
    validatedParams["custody_account_id"] = params.contact_company_id;
  }
  const initialData = {
    EndDate: "",
  };

  const [custodyAccountData, setCustodyAccountData] = useState(initialData);
  const [loadingData, setLoadingData] = useState(true);

  const [validationErrors, setValidationError] = useState({});

  const fieldsToValidate = {
    CustodyAccount: ValidateRequired,
    EndDate: ValidateRequired,
    ThresholdAmount: ValidateRequired,
    StartDate: ValidateRequired,
    CustodyAccountSuffix: ValidateRequired,
  };

  const { CustodyAccount, CustodyAccountSuffix, StartDate, EndDate, ThresholdAmount } = custodyAccountData;

  const handleSubmit = async () => {
    const formIsValid = true;
    if (formIsValid) {
      try {
        // validation happens here, then if valid
        setLoadingData(true);
        let CustodyAccount = {
          ...custodyAccountData,
        };
        CustodyAccount.ThresholdAmount = Number(CustodyAccount.ThresholdAmount);
        let endpoint = `/gmmCustodyAccountMaster`;
        let formattedData = JSON.stringify(CustodyAccount);
        let httpMethod = "PUT";
        if (Object.keys(validatedParams).length === 0) {
          httpMethod = "POST";
        } else {
          endpoint = `/gmmCustodyAccountMaster/${validatedParams.custody_account_id}`;
        }
        let response = await fetchService(baseUrl + endpoint, {
          method: httpMethod,
          body: formattedData,
          token: accessToken,
        });
        if (200 !== response.status) {
          throw new Error();
        } else {
          navigate(`/custody-account-management`);
        }
      } catch (error) {
        navigate("/error", { state: { error } });
      }
    }
  };

  const getCompany = async () => {
    let endpoint = `/gmmCustodyAccountMaster/${validatedParams.custody_account_id}`;
    let response = await fetchService(baseUrl + endpoint, { method: "GET", token: accessToken });
    let resp = await response.json();
    if (200 !== response.status) {
      const requestId = resp["requestId"];
      throw new Error(requestId);
    }
    if (resp.length === 0) {
      throw new Error(resp.requestId);
    }
    return resp;
  };

  useEffect(() => {
    if (Object.keys(validatedParams).length === 0) {
      setLoadingData(false);
    } else {
      const setupAPIData = async () => {
        try {
          let companyDetails = await getCompany();
          let company = companyDetails[0];
          setCustodyAccountData(company);
          setLoadingData(false);
        } catch (error) {
          navigate("/error", { state: { error } });
        }
      };
      setupAPIData();
    }
  }, []);

  useEffect(() => {
    validationUseEffectHelper("CustodyAccount", CustodyAccount, fieldsToValidate, validationErrors, setValidationError);
  }, [CustodyAccount]);

  useEffect(() => {
    validationUseEffectHelper("EndDate", EndDate, fieldsToValidate, validationErrors, setValidationError);
  }, [EndDate]);

  useEffect(() => {
    validationUseEffectHelper(
      "ThresholdAmount",
      ThresholdAmount,
      fieldsToValidate,
      validationErrors,
      setValidationError
    );
  }, [ThresholdAmount]);

  useEffect(() => {
    validationUseEffectHelper(
      "CustodyAccountSuffix",
      CustodyAccountSuffix,
      fieldsToValidate,
      validationErrors,
      setValidationError
    );
  }, [CustodyAccountSuffix]);

  if (!loadingData) {
    return (
      <div>
        <Col>
          <Row>
            <Col sm={9}>
              <h2>
                {Object.keys(validatedParams).length === 0
                  ? "New Custody Account Detail"
                  : "Edit Custody Account Detail"}
              </h2>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Card heading={"Custody Account Detail"}>
                <Row>
                  <Col sm={8}>
                    <Input
                      data-testid={"CustodyAccount"}
                      id={"CustodyAccount"}
                      type="text"
                      label="Custody Account Number"
                      value={CustodyAccount}
                      errorMessage={validationErrors["CustodyAccount"]}
                      onChange={(e) => {
                        handleChange(e, "CustodyAccount", setCustodyAccountData);
                      }}
                    ></Input>
                  </Col>
                </Row>
                <Row>
                  <Col sm={5}>
                    <Input
                      data-testid={"CustodyAccountSuffix"}
                      id={"CustodyAccountSuffix"}
                      type="text"
                      className="util-margin-top-sm-15 util-margin-top-xs-30"
                      value={CustodyAccountSuffix}
                      label="Custody Account Suffix"
                      errorMessage={validationErrors["CustodyAccountSuffix"]}
                      onChange={(e) => {
                        handleChange(e, "CustodyAccountSuffix", setCustodyAccountData);
                      }}
                    ></Input>
                  </Col>
                </Row>
                <Row>
                  <Col sm={3}>
                    <Input
                      data-testid={"StartDate"}
                      id={"StartDate"}
                      type="date"
                      className="util-margin-top-sm-15 util-margin-top-xs-30"
                      value={StartDate}
                      label="Start Date"
                      onChange={(e) => {
                        handleChange(e, "StartDate", setCustodyAccountData);
                      }}
                    ></Input>
                  </Col>
                </Row>
                <Row>
                  <Col sm={3}>
                    <Input
                      data-testid={"EndDate"}
                      id={"EndDate"}
                      type="date"
                      className="util-margin-top-sm-15 util-margin-top-xs-30"
                      value={EndDate}
                      label="End Date"
                      onChange={(e) => {
                        handleChange(e, "EndDate", setCustodyAccountData);
                      }}
                    ></Input>
                  </Col>
                </Row>
                <Row>
                  <Col sm={5}>
                    <Input
                      data-testid={"ThresholdAmount"}
                      id={"ThresholdAmount"}
                      type="number"
                      className="util-margin-top-sm-15 util-margin-top-xs-30"
                      label="Threshold Amount"
                      value={ThresholdAmount}
                      errorMessage={validationErrors["ThresholdAmount"]}
                      onChange={(e) => {
                        handleChange(e, "ThresholdAmount", setCustodyAccountData);
                      }}
                    ></Input>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col sm={12} style={{ textAlign: "right" }} className="util-margin-top-sm-15 util-margin-top-xs-30">
              <Button
                data-testid={"saveChanges"}
                style={{ marginRight: 15 }}
                onClick={() => {
                  handleSubmit();
                }}
              >
                Save Changes
              </Button>
              <Button
                data-testid={"discardChanges"}
                onClick={() => {
                  navigate(`/custody-account-management`);
                }}
              >
                Discard Changes
              </Button>
            </Col>
          </Row>
        </Col>
      </div>
    );
  } else {
    return <Loading></Loading>;
  }
};

export default CompanyDetailsEdit;
